export default "__VITE_ASSET__B4A3HAOb__"